import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propId, propStr, } from '../../../../helpers/custom-prop-types';
const MyFavoriteSlideCheckBox = (props) => {
    const { checked, id, name, onChange, value } = props;
    return (_jsxs("div", Object.assign({ className: 'slide-box-check' }, { children: [_jsx("input", { checked: checked, className: 'mdc-checkbox__native-control', id: id, name: name, onChange: onChange, type: 'checkbox', value: value }), _jsx("label", { htmlFor: id })] })));
};
MyFavoriteSlideCheckBox.propTypes = {
    checked: propBool().isRequired,
    id: propStr().isRequired,
    name: propStr().isRequired,
    onChange: propFunc().isRequired,
    value: propId().isRequired,
};
export default MyFavoriteSlideCheckBox;
